import { compose } from 'recompose';
import apiInterceptor from '../../../api/interceptor';
import PurchaseVatReport from './PurchaseVatReport';
import { purchaseVatApi } from '../../common/base.api';

const composedPurchaseVatReport = compose(apiInterceptor({ ...purchaseVatApi }))(PurchaseVatReport);

export default composedPurchaseVatReport;
